"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchOrderItemById = exports.filterCompletePayment = exports.getSectionNameFromOrder = exports.getTableNameFromOrder = exports.getTablesFromOrder = exports.canPerformTransfer = exports.isCompletedOrRefundedPayment = exports.isOnAccountPayment = exports.getOnAccountPayment = exports.getCurrentQuantity = exports.isInventoryBeingTracked = exports.getTipsFromPayments = exports.getOrderAdjustments = exports.getAdjustmentLabel = exports.getItemRewardValue = exports.multiplyDecimals = exports.sumDecimals = exports.limitDecimalCount = exports.isOrderEditable = exports.getPrintableOrderItems = exports.getItemsToCheckForPrint = exports.getComboItems = exports.updateOrderAndItemsStatus = exports.mergeIdenticalOrderItems = exports.getPaymentSurchargeValueAndPaidAmount = exports.getPaymentAdjustmentValue = exports.getApplicableScheduleAdjustments = exports.isScheduleAdjustmentsAppliedInCart = exports.getScheduleAdjustments = exports.getNetSubTotal = exports.getAdjustmentValue = exports.generateNextOrderNumberForOnline = exports.generateNextOrderNumber = exports.getOrderPrefix = exports.getOrderNumberDigitFromOrderNumber = exports.updateRemovedOrderItemDetails = exports.isItemEditable = exports.INVALID_VOID_ITEM_STATUS = exports.VALID_FIRE_ITEM_STATUS = exports.bindTrailingArgs = exports.isRefunded = exports.clone = exports.ALL_ALLERGENS_KEY = exports.INVALID_ORDER_PREFIX = exports.INVALID_ORDER_NUMBER = exports.REFUND_ORDER_ITEM = void 0;
const domain_1 = require("@oolio-group/domain");
const format_1 = __importDefault(require("date-fns/format"));
const computePrice_1 = require("./computePrice");
const currency_formatter_1 = require("currency-formatter");
const moment_1 = __importDefault(require("moment"));
const decimal_js_1 = __importDefault(require("decimal.js"));
const date_fns_1 = require("date-fns");
const advancedDiscountHelper_1 = require("./advancedDiscountHelper");
const ORDER_NUMBER_MIN_SPLIT = 3;
const ORDER_NUMBER_SEPARATOR = '-';
const ORDER_NUMBER_DATE_FORMAT = 'yyyyMMdd';
exports.REFUND_ORDER_ITEM = {
    id: 'REFUND_ORDER_ITEM_ID',
    name: 'Custom Amount',
};
exports.INVALID_ORDER_NUMBER = -1;
exports.INVALID_ORDER_PREFIX = 'INVALID';
exports.ALL_ALLERGENS_KEY = 'all';
/**
 * Deep clone an object
 * Circular properties not supported.
 * Only JSON convertible objects are supported
 * @param obj object to be cloned
 */
function clone(obj) {
    if (!obj) {
        return obj;
    }
    return JSON.parse(JSON.stringify(obj));
}
exports.clone = clone;
function isRefunded(item) {
    if (item) {
        return item.status === domain_1.OrderItemStatus.REFUNDED;
    }
    else {
        return false;
    }
}
exports.isRefunded = isRefunded;
const bindTrailingArgs = (fn, ...extras) => {
    return (...args) => {
        return fn(...args, ...extras);
    };
};
exports.bindTrailingArgs = bindTrailingArgs;
const ORDER_ITEM_EDITABLE_STATUS = new Set([
    domain_1.OrderItemStatus.DRAFT,
    domain_1.OrderItemStatus.CREATED,
    domain_1.OrderItemStatus.ON_HOLD,
    domain_1.OrderItemStatus.IN_PROGRESS,
]);
exports.VALID_FIRE_ITEM_STATUS = [
    domain_1.OrderItemStatus.IN_PROGRESS,
    domain_1.OrderItemStatus.VOID,
    domain_1.OrderItemStatus.COMPLETED,
];
exports.INVALID_VOID_ITEM_STATUS = [
    domain_1.OrderItemStatus.VOID,
    domain_1.OrderItemStatus.CANCELLED,
    domain_1.OrderItemStatus.TRANSFERRED,
];
/**
 * Checks whether the item is editable or not, based on their status
 * @param item OrderItem
 */
function isItemEditable(item) {
    return ORDER_ITEM_EDITABLE_STATUS.has(item.status);
}
exports.isItemEditable = isItemEditable;
/**
 * Update removed order item details,
 * "status" and "reason" for now.
 * @param orderItem OrderItem
 * @param reason String
 */
function updateRemovedOrderItemDetails(orderItem, reason) {
    switch (orderItem.status) {
        case domain_1.OrderItemStatus.CREATED:
        case domain_1.OrderItemStatus.ON_HOLD:
            orderItem.status = domain_1.OrderItemStatus.CANCELLED;
            break;
        case domain_1.OrderItemStatus.IN_PROGRESS:
            orderItem.status = domain_1.OrderItemStatus.VOID;
            orderItem.reason = reason;
            orderItem.itemFired = false;
            break;
    }
    return orderItem;
}
exports.updateRemovedOrderItemDetails = updateRemovedOrderItemDetails;
const getOrderNumberDigitFromOrderNumber = (orderNumber) => {
    if (!orderNumber) {
        return;
    }
    if (!orderNumber.includes(ORDER_NUMBER_SEPARATOR))
        return exports.INVALID_ORDER_NUMBER;
    const orderNumberSplit = orderNumber.split(ORDER_NUMBER_SEPARATOR);
    if (orderNumberSplit.length < ORDER_NUMBER_MIN_SPLIT)
        return exports.INVALID_ORDER_NUMBER;
    return Number(orderNumberSplit[orderNumberSplit.length - 2]);
};
exports.getOrderNumberDigitFromOrderNumber = getOrderNumberDigitFromOrderNumber;
const getOrderPrefix = (orderNumber) => {
    if (!orderNumber) {
        return;
    }
    if (!orderNumber.includes(ORDER_NUMBER_SEPARATOR))
        return exports.INVALID_ORDER_PREFIX;
    const orderNumberSplit = orderNumber.split(ORDER_NUMBER_SEPARATOR);
    if (orderNumberSplit.length < ORDER_NUMBER_MIN_SPLIT)
        return exports.INVALID_ORDER_PREFIX;
    orderNumberSplit.splice(orderNumberSplit.length - 2, 2);
    return orderNumberSplit.join(ORDER_NUMBER_SEPARATOR);
};
exports.getOrderPrefix = getOrderPrefix;
const generateNextOrderNumber = (date, salesPrefix, lastOrderNumber) => {
    let lastNumber = 0;
    const orderNumber = (0, exports.getOrderNumberDigitFromOrderNumber)(lastOrderNumber);
    if (orderNumber && orderNumber !== exports.INVALID_ORDER_NUMBER)
        lastNumber = orderNumber;
    return `${salesPrefix}${ORDER_NUMBER_SEPARATOR}${lastNumber + 1}${ORDER_NUMBER_SEPARATOR}${(0, format_1.default)(date, ORDER_NUMBER_DATE_FORMAT)}`;
};
exports.generateNextOrderNumber = generateNextOrderNumber;
const generateNextOrderNumberForOnline = (date, salesPrefix, lastOrderNumber) => {
    let lastNumber = 0;
    const orderNumber = (0, exports.getOrderNumberDigitFromOrderNumber)(lastOrderNumber);
    if (orderNumber && orderNumber !== exports.INVALID_ORDER_NUMBER)
        lastNumber = orderNumber;
    return `${salesPrefix}${ORDER_NUMBER_SEPARATOR}${lastNumber + 1}${ORDER_NUMBER_SEPARATOR}${(0, format_1.default)(date, 'ddhhmmss')}`;
};
exports.generateNextOrderNumberForOnline = generateNextOrderNumberForOnline;
function getAdjustmentValue(price, adjustments, filter) {
    if (!adjustments || adjustments.length === 0) {
        return 0;
    }
    let adjustmentsArray = adjustments;
    if (filter === null || filter === void 0 ? void 0 : filter.adjustmentType) {
        adjustmentsArray = adjustments === null || adjustments === void 0 ? void 0 : adjustments.filter(adjustment => (adjustment === null || adjustment === void 0 ? void 0 : adjustment.adjustmentType) == (filter === null || filter === void 0 ? void 0 : filter.adjustmentType));
    }
    if (filter === null || filter === void 0 ? void 0 : filter.escapePaymentType) {
        adjustmentsArray = adjustmentsArray === null || adjustmentsArray === void 0 ? void 0 : adjustmentsArray.filter(adjustment => !(adjustment === null || adjustment === void 0 ? void 0 : adjustment.allowOnPaymentType));
    }
    if (!adjustmentsArray || adjustmentsArray.length === 0) {
        return 0;
    }
    const adjustmentValue = adjustmentsArray
        .reduce((total, adjustment) => {
        let amount = new decimal_js_1.default(adjustment.amount || 0);
        if (!isNaN(adjustment.quantity) && adjustment.quantity !== null) {
            amount = amount.times(adjustment.quantity);
        }
        const getAdjustmentAmount = {
            [domain_1.AdjustmentUnit.PERCENTAGE]: function () {
                return amount.times(price).times(0.01);
            },
            [domain_1.AdjustmentUnit.FLAT]: function () {
                return amount;
            },
        };
        let adjustedAmount = getAdjustmentAmount[adjustment === null || adjustment === void 0 ? void 0 : adjustment.adjustmentUnit]();
        if (!isNaN(adjustment.maximumAmount) &&
            adjustment.maximumAmount !== null &&
            adjustment.maximumAmount !== 0) {
            const sign = decimal_js_1.default.sign(adjustedAmount);
            adjustedAmount = decimal_js_1.default.min(decimal_js_1.default.abs(adjustedAmount), decimal_js_1.default.abs(adjustment.maximumAmount)).times(sign);
        }
        return adjustedAmount.add(total);
    }, new decimal_js_1.default(price || 0))
        .minus(price);
    // prevent discount value (negative) to surpass actual price
    return Math.max(adjustmentValue.toNumber(), -price);
}
exports.getAdjustmentValue = getAdjustmentValue;
function getNetSubTotal(subTotal, adjustments = []) {
    //We're going to exclude adjustments which is marked on payment
    const filteredAdjustments = adjustments === null || adjustments === void 0 ? void 0 : adjustments.filter(a => !a.allowOnPaymentType);
    if (!filteredAdjustments ||
        !filteredAdjustments.some(a => a.doNotIncludeInSalesAmount))
        return subTotal;
    const adjustmentsOnSubTotal = filteredAdjustments.filter(a => !a.doNotIncludeInSalesAmount);
    const adjustmentValue = getAdjustmentValue(subTotal, adjustmentsOnSubTotal);
    return adjustmentValue ? sumDecimals([subTotal, adjustmentValue]) : subTotal;
}
exports.getNetSubTotal = getNetSubTotal;
const getApplicableScheduleBasedOnFilter = (s, orderItemTime) => {
    const currentDay = (0, moment_1.default)().isoWeekday();
    const orderItemCreatedTime = (0, moment_1.default)(orderItemTime);
    const scheduleDay = (0, moment_1.default)().isoWeekday(s.day).isoWeekday();
    const scheduleStartTime = (0, moment_1.default)(s.timeSlot.startTime, 'HH:mm');
    const scheduleEndTime = (0, moment_1.default)(s.timeSlot.endTime, 'HH:mm');
    if (scheduleDay === currentDay &&
        s.isActive &&
        orderItemCreatedTime.isSameOrAfter(scheduleStartTime) &&
        orderItemCreatedTime.isSameOrBefore(scheduleEndTime)) {
        return true;
    }
    else
        return false;
};
/*
We would check adjustment order type only if adjustment.orderType is exist
Otherwise return true so it would work follow the workflow
*/
const isAdjustmentOrderTypeExist = (adjustment, orderType) => {
    var _a;
    const adjustmentOrderTypes = adjustment.orderTypes || ((_a = adjustment.triggerRules) === null || _a === void 0 ? void 0 : _a.orderTypes);
    if (!(adjustmentOrderTypes === null || adjustmentOrderTypes === void 0 ? void 0 : adjustmentOrderTypes.length) || !orderType)
        return true;
    else {
        return adjustmentOrderTypes === null || adjustmentOrderTypes === void 0 ? void 0 : adjustmentOrderTypes.some(type => type === orderType);
    }
};
const isCustomerEligibleForAdjustment = (adjustment, customerGroupIds = []) => {
    var _a;
    if (!((_a = adjustment.customerGroupIds) === null || _a === void 0 ? void 0 : _a.length))
        return true;
    return adjustment.customerGroupIds.some(id => customerGroupIds.includes(id));
};
const isAdjustmentApplicableInStore = (adjustment, storeId) => {
    var _a, _b;
    if (!((_a = adjustment.stores) === null || _a === void 0 ? void 0 : _a.length) || !storeId)
        return true;
    else {
        return (_b = adjustment.stores) === null || _b === void 0 ? void 0 : _b.some(id => id === storeId);
    }
};
const isAdvanceRuleApplicable = (adjustment, { guestCount: orderGuestCount = 0 } = {}) => {
    var _a;
    const isAdvanceRuleEnabled = adjustment.isAdvanceRuleEnabled;
    const advanceRules = adjustment.advanceRules;
    if (!isAdvanceRuleEnabled ||
        !advanceRules ||
        adjustment.adjustmentType === domain_1.AdjustmentType.DISCOUNT)
        return true;
    let isValid = false;
    switch (advanceRules.applyOn) {
        case domain_1.AdjustmentRule.GUEST_COUNT:
            const adjustmentGuestCount = (_a = advanceRules === null || advanceRules === void 0 ? void 0 : advanceRules.guestCount) !== null && _a !== void 0 ? _a : 0;
            if (orderGuestCount >= adjustmentGuestCount) {
                isValid = true;
            }
            break;
    }
    return isValid;
};
const isDateRangeValid = (adjustment) => {
    var _a;
    const currentDate = Math.floor(Date.now() / 1000);
    let isWithinSchedule = false;
    if (((_a = adjustment === null || adjustment === void 0 ? void 0 : adjustment.dateTimeRange) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        isWithinSchedule = adjustment.dateTimeRange.some(range => {
            return (0, date_fns_1.isWithinInterval)(currentDate, {
                start: range.startDate,
                end: range.endDate,
            });
        });
    }
    return isWithinSchedule;
};
const isActiveSchedule = (adjustment) => {
    var _a, _b, _c;
    return ((_c = (((_a = adjustment === null || adjustment === void 0 ? void 0 : adjustment.schedule) === null || _a === void 0 ? void 0 : _a.length) &&
        ((_b = adjustment === null || adjustment === void 0 ? void 0 : adjustment.schedule) === null || _b === void 0 ? void 0 : _b.every(item => item.isActive !== false)))) !== null && _c !== void 0 ? _c : false);
};
const isAdjustmentDateRangeDefined = (adjustment) => {
    var _a;
    if ((adjustment.isScheduledEnabled !== false && isActiveSchedule(adjustment)) ||
        (adjustment.isDateRangeEnabled && ((_a = adjustment.dateTimeRange) === null || _a === void 0 ? void 0 : _a.length))) {
        return true;
    }
    else
        return false;
};
const isScheduledAdjustmentValid = (adjustment, orderItemCreatedTime, isManuallyTriggered) => {
    var _a, _b;
    if (isManuallyTriggered && !isAdjustmentDateRangeDefined(adjustment)) {
        return true;
    }
    // checks for scheduled and date ranges
    if (adjustment.isScheduledEnabled !== false &&
        isActiveSchedule(adjustment) &&
        adjustment.isDateRangeEnabled) {
        return (((_a = adjustment.schedule) === null || _a === void 0 ? void 0 : _a.some(s => getApplicableScheduleBasedOnFilter(s, orderItemCreatedTime))) && isDateRangeValid(adjustment));
    }
    if (adjustment.isScheduledEnabled !== false && isActiveSchedule(adjustment)) {
        return (_b = adjustment.schedule) === null || _b === void 0 ? void 0 : _b.some(s => getApplicableScheduleBasedOnFilter(s, orderItemCreatedTime));
    }
    if (adjustment.isDateRangeEnabled) {
        return isDateRangeValid(adjustment);
    }
};
const isAdvanceDiscountAppliedOnItems = (advancedDiscountIds, adjustment) => {
    return ((advancedDiscountIds === null || advancedDiscountIds === void 0 ? void 0 : advancedDiscountIds.includes(adjustment.id)) &&
        (adjustment === null || adjustment === void 0 ? void 0 : adjustment.isDiscountRuleEnabled));
};
// This function find the schedule adjustments
const getScheduleAdjustments = (adjustments = [], orderItems = [], adjustmentInfo = {}) => {
    var _a, _b, _c, _d, _e, _f;
    let adjustmentByOrderItem = {};
    if (!(adjustments === null || adjustments === void 0 ? void 0 : adjustments.length)) {
        return {
            validAdjustments: [],
            invalidAdjustmentIds: [],
            adjustmentByOrderItem,
        };
    }
    const { guestCount = 0, selectedOrderType = '', storeId = '', isManuallyTriggered = false, appliedAdvanceDiscountIdsOnItems = [], customerGroupIds = [], existingOrderLevelAdjustments = [], } = adjustmentInfo || {};
    const existingOrderItemLevelAdjustments = (_a = orderItems === null || orderItems === void 0 ? void 0 : orderItems.flatMap(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.adjustments) !== null && _a !== void 0 ? _a : []; }).map(a => adjustments.find(adjustment => adjustment.id === a.id)).filter(Boolean)) !== null && _a !== void 0 ? _a : [];
    const mappedExistingOrderLevelAdjustments = (_c = (_b = (existingOrderLevelAdjustments || [])) === null || _b === void 0 ? void 0 : _b.map(a => adjustments.find(adjustment => adjustment.id === a.id)).filter(Boolean)) !== null && _c !== void 0 ? _c : [];
    // This block only validate the adjustments which is marked as autoApply
    // or it is applied via function map
    if (!isManuallyTriggered) {
        adjustments = adjustments.filter(a => a.autoApply || (appliedAdvanceDiscountIdsOnItems === null || appliedAdvanceDiscountIdsOnItems === void 0 ? void 0 : appliedAdvanceDiscountIdsOnItems.includes(a.id)));
    }
    const orderItemCreatedTime = ((_d = orderItems === null || orderItems === void 0 ? void 0 : orderItems[0]) === null || _d === void 0 ? void 0 : _d.createdAt) || (0, moment_1.default)().valueOf();
    const scheduleAdjustments = adjustments === null || adjustments === void 0 ? void 0 : adjustments.filter(a => !a.allowOnPaymentType &&
        (isScheduledAdjustmentValid(a, orderItemCreatedTime, isManuallyTriggered) ||
            isAdvanceDiscountAppliedOnItems(appliedAdvanceDiscountIdsOnItems, a)));
    const validAdjustments = scheduleAdjustments.filter(a => isAdjustmentOrderTypeExist(a, selectedOrderType) &&
        isCustomerEligibleForAdjustment(a, customerGroupIds) &&
        isAdjustmentApplicableInStore(a, storeId) &&
        isAdvanceRuleApplicable(a, {
            guestCount,
            selectedOrderType,
        }));
    const promoDiscounts = [], scheduledOrderAdjustments = [];
    validAdjustments.forEach(a => {
        if (a.isDiscountRuleEnabled)
            promoDiscounts.push(a);
        else
            scheduledOrderAdjustments.push(a);
    });
    if (promoDiscounts.length) {
        const filteredItems = orderItems.filter(i => ![
            domain_1.OrderItemStatus.VOID,
            domain_1.OrderItemStatus.CANCELLED,
            domain_1.OrderItemStatus.TRANSFERRED,
        ].includes(i.status));
        adjustmentByOrderItem = (0, advancedDiscountHelper_1.getAdvancedDiscount)(filteredItems, promoDiscounts, isManuallyTriggered);
    }
    const validAdjustmentIds = validAdjustments.map(a => a.id);
    const invalidItemAdjustmentIds = (_e = existingOrderItemLevelAdjustments === null || existingOrderItemLevelAdjustments === void 0 ? void 0 : existingOrderItemLevelAdjustments.filter(a => !isCustomerEligibleForAdjustment(a, customerGroupIds)).map(a => a.id)) !== null && _e !== void 0 ? _e : [];
    const invalidOrderAdjustmentIds = (_f = mappedExistingOrderLevelAdjustments === null || mappedExistingOrderLevelAdjustments === void 0 ? void 0 : mappedExistingOrderLevelAdjustments.filter(a => !isCustomerEligibleForAdjustment(a, customerGroupIds)).map(a => a.id)) !== null && _f !== void 0 ? _f : [];
    const invalidAdjustmentIds = scheduleAdjustments
        .filter(a => !validAdjustmentIds.includes(a.id))
        .map(a => a.id);
    return {
        validAdjustments: scheduledOrderAdjustments,
        invalidAdjustmentIds: [
            ...new Set([
                ...invalidAdjustmentIds,
                ...invalidItemAdjustmentIds,
                ...invalidOrderAdjustmentIds,
            ]),
        ],
        adjustmentByOrderItem,
    };
};
exports.getScheduleAdjustments = getScheduleAdjustments;
const isScheduleAdjustmentsAppliedInCart = (scheduleAdjustments = [], orderAdjustments = []) => {
    const orderAdjustmentIds = orderAdjustments.map(a => a.id);
    return scheduleAdjustments.every(a => orderAdjustmentIds.includes((a === null || a === void 0 ? void 0 : a.id) || ''));
};
exports.isScheduleAdjustmentsAppliedInCart = isScheduleAdjustmentsAppliedInCart;
const getApplicableScheduleAdjustments = (scheduleAdjustments = [], orderAdjustments = []) => {
    const orderAdjustmentIds = (orderAdjustments === null || orderAdjustments === void 0 ? void 0 : orderAdjustments.map(a => a.id)) || [];
    return ((scheduleAdjustments === null || scheduleAdjustments === void 0 ? void 0 : scheduleAdjustments.filter(a => !orderAdjustmentIds.includes(a === null || a === void 0 ? void 0 : a.id))) || []);
};
exports.getApplicableScheduleAdjustments = getApplicableScheduleAdjustments;
function getPaymentAdjustmentValue(price, adjustments) {
    const adjustmentsArray = adjustments === null || adjustments === void 0 ? void 0 : adjustments.filter(adjustment => adjustment === null || adjustment === void 0 ? void 0 : adjustment.allowOnPaymentType);
    if ((adjustmentsArray === null || adjustmentsArray === void 0 ? void 0 : adjustmentsArray.length) == 0)
        return 0;
    return adjustmentsArray === null || adjustmentsArray === void 0 ? void 0 : adjustmentsArray.reduce((total, adjustment) => {
        let amount = 0;
        const getAdjustmentAmount = {
            [domain_1.AdjustmentUnit.PERCENTAGE]: function () {
                amount = total * adjustment.amount * 0.01;
                return amount;
            },
            [domain_1.AdjustmentUnit.FLAT]: function () {
                amount = adjustment.amount;
                return amount;
            },
        };
        return getAdjustmentAmount[adjustment === null || adjustment === void 0 ? void 0 : adjustment.adjustmentUnit]();
    }, price);
}
exports.getPaymentAdjustmentValue = getPaymentAdjustmentValue;
//use this function to accurately calculaye payment surcharge
function getPaymentSurchargeValueAndPaidAmount(orderPayments) {
    const completedPayments = orderPayments.filter(payment => {
        var _a;
        return (payment.status === undefined ||
            isCompletedOrRefundedPayment(payment.status) ||
            ((_a = payment.paymentType) === null || _a === void 0 ? void 0 : _a.name) === domain_1.OrderAction.ON_ACCOUNT_PAYMENT_TYPE);
    });
    return completedPayments.reduce((acc, payment) => {
        return {
            paymentSurcharge: sumDecimals([
                acc.paymentSurcharge,
                payment.paymentSurcharge || 0,
            ]),
            paidAmount: sumDecimals([
                acc.paidAmount,
                payment.amount,
                -(payment.roundOffDifference || 0),
            ]),
        };
    }, { paymentSurcharge: 0, paidAmount: 0 });
}
exports.getPaymentSurchargeValueAndPaidAmount = getPaymentSurchargeValueAndPaidAmount;
/**
 * Merge order items has same
 * */
const mergeIdenticalOrderItems = (orderItems) => {
    if (!orderItems)
        return orderItems;
    return orderItems.reduce((acc, orderItem) => {
        var _a, _b, _c, _d;
        if (orderItem.notes ||
            orderItem.discountAmount ||
            ((_a = orderItem.modifiers) === null || _a === void 0 ? void 0 : _a.length) ||
            ((_b = orderItem.product) === null || _b === void 0 ? void 0 : _b.variableQuantity) ||
            ((_c = orderItem.comboItems) === null || _c === void 0 ? void 0 : _c.length) ||
            ((_d = orderItem.parentCombo) === null || _d === void 0 ? void 0 : _d.id) ||
            orderItem.status === domain_1.OrderItemStatus.TRANSFERRED ||
            orderItem.transferInfo) {
            acc.push(orderItem);
        }
        else {
            const duplicateItemIndex = acc.findIndex(item => {
                var _a, _b, _c, _d, _e, _f;
                return !item.notes &&
                    !item.discountAmount &&
                    !((_a = item === null || item === void 0 ? void 0 : item.modifiers) === null || _a === void 0 ? void 0 : _a.length) &&
                    !((_b = orderItem.product) === null || _b === void 0 ? void 0 : _b.variableQuantity) &&
                    (orderItem.paymentStatus !== domain_1.OrderPaymentStatus.COMPLETE ||
                        orderItem.paymentStatus === item.paymentStatus) &&
                    item.product.id === orderItem.product.id &&
                    item.unitPrice === orderItem.unitPrice &&
                    ((_c = item === null || item === void 0 ? void 0 : item.variant) === null || _c === void 0 ? void 0 : _c.id) === ((_d = orderItem === null || orderItem === void 0 ? void 0 : orderItem.variant) === null || _d === void 0 ? void 0 : _d.id) &&
                    item.status === orderItem.status &&
                    item.reason === orderItem.reason &&
                    item.itemFired == orderItem.itemFired &&
                    (item === null || item === void 0 ? void 0 : item.saved) == (orderItem === null || orderItem === void 0 ? void 0 : orderItem.saved) &&
                    ((_e = item === null || item === void 0 ? void 0 : item.course) === null || _e === void 0 ? void 0 : _e.id) === ((_f = orderItem === null || orderItem === void 0 ? void 0 : orderItem.course) === null || _f === void 0 ? void 0 : _f.id) &&
                    (item === null || item === void 0 ? void 0 : item.seatNumber) == orderItem.seatNumber &&
                    (item === null || item === void 0 ? void 0 : item.paymentStatus) == orderItem.paymentStatus &&
                    (item === null || item === void 0 ? void 0 : item.originalOrderItemId) == (orderItem === null || orderItem === void 0 ? void 0 : orderItem.originalOrderItemId);
            });
            if (duplicateItemIndex < 0) {
                acc.push(orderItem);
            }
            else {
                // quantity can be decimal -> 1.9 + 0.99 = 2.8899999999999997 -> break UI
                acc[duplicateItemIndex].quantity = limitDecimalCount(acc[duplicateItemIndex].quantity + orderItem.quantity);
                acc[duplicateItemIndex].mergedOrderItemIds = [
                    ...(acc[duplicateItemIndex].mergedOrderItemIds || []),
                    ...(orderItem.mergedOrderItemIds || []),
                    orderItem.id,
                ];
            }
        }
        return acc;
    }, []);
};
exports.mergeIdenticalOrderItems = mergeIdenticalOrderItems;
/**
 * Updates Order And Order Items status
 * @param order Order
 * @param newOrderStatus OrderStatus
 * @param newItemStatus OrderItemStatus
 * @requires ORDER_ITEM_EDITABLE_STATUS
 */
function updateOrderAndItemsStatus(order, newOrderStatus, newItemStatus) {
    order.status = newOrderStatus;
    if (Array.isArray(order.orderItems) && order.orderItems.length > 0) {
        order.orderItems.forEach(item => {
            if (ORDER_ITEM_EDITABLE_STATUS.has(item.status)) {
                item.status = newItemStatus;
            }
        });
    }
}
exports.updateOrderAndItemsStatus = updateOrderAndItemsStatus;
function getComboItems(orderItems) {
    return orderItems.map(i => i.comboItems || []).flat();
}
exports.getComboItems = getComboItems;
/**
 * This will return all the items present in cart + combo items present under item -> comboItems
 */
function getItemsToCheckForPrint(orderItems) {
    var _a;
    let comboItems = [];
    const filteredItems = (_a = (orderItems || [])) === null || _a === void 0 ? void 0 : _a.filter(i => { var _a, _b; return !((_a = i.parentCombo) === null || _a === void 0 ? void 0 : _a.id) && !((_b = i.comboItems) === null || _b === void 0 ? void 0 : _b.length); });
    comboItems = (orderItems || [])
        .map(i => (i.comboItems || []).map((comboItem) => ({
        ...comboItem,
        quantity: (i.quantity || 1) * (comboItem.quantity || 1),
        reason: i.reason,
    })))
        .flat();
    return [...filteredItems, ...comboItems];
}
exports.getItemsToCheckForPrint = getItemsToCheckForPrint;
/**
 * get printable orderItems from order
 * @param orderItems OrderItem
 * @returns orderItems[]
 */
function getPrintableOrderItems(orderItems) {
    const filteredItems = getItemsToCheckForPrint(orderItems);
    return (filteredItems || []).filter(item => (item.status === domain_1.OrderItemStatus.VOID ||
        item.status === domain_1.OrderItemStatus.IN_PROGRESS ||
        item.status === domain_1.OrderItemStatus.COMPLETED) &&
        !item.itemFired);
}
exports.getPrintableOrderItems = getPrintableOrderItems;
function isOrderEditable(orderStatus) {
    return domain_1.EDITABLE_ORDER_STATUS.includes(orderStatus);
}
exports.isOrderEditable = isOrderEditable;
/**
 * Limit decimal places of number to the default count of 2
 *
 * @param value the value to be processed
 * @param decimalCount number of decimal places, default to 2
 * @returns the number after decimal places cut
 */
function limitDecimalCount(value, decimalCount = 2) {
    // do it with Decimal.js to ensure floating precision
    return +new decimal_js_1.default(value || 0).toFixed(decimalCount);
}
exports.limitDecimalCount = limitDecimalCount;
/**
 * Sums all decimals and maintain decimal precision
 *
 * @param values values to be summed
 * @returns the total value after sums
 */
function sumDecimals(values) {
    const nonNullValues = values === null || values === void 0 ? void 0 : values.filter(val => !!val);
    if (!(nonNullValues === null || nonNullValues === void 0 ? void 0 : nonNullValues.length)) {
        return 0;
    }
    // Note: use Decimal.js as type to avoid losing values with floating point precision
    return decimal_js_1.default.sum(...nonNullValues).toNumber();
}
exports.sumDecimals = sumDecimals;
/**
 * Multiply decimals and maintain decimal precision
 *
 * @param x, y values to be multiply
 * @returns the total value after multiply
 */
function multiplyDecimals(x, y, decimalCount = 2) {
    // Note: use Decimal.js as type to avoid losing values with floating point precision
    return +decimal_js_1.default.mul(x, y).toNumber().toFixed(decimalCount);
}
exports.multiplyDecimals = multiplyDecimals;
function getItemRewardValue(item, adjustments) {
    return (adjustments || [])
        .filter(adj => adj.adjustmentType === domain_1.AdjustmentType.REWARD)
        .reduce((totalReward, adj) => {
        const revisedQuantity = Math.min(item.quantity, adj.itemQuantity || item.quantity);
        // Calculate price using revised quantity
        const itemPrice = (0, computePrice_1.computeLineTotal)({
            ...item,
            quantity: revisedQuantity,
        });
        return totalReward + getAdjustmentValue(itemPrice, [adj]);
    }, 0);
}
exports.getItemRewardValue = getItemRewardValue;
const getAdjustmentLabel = (adjustment) => {
    if (!adjustment)
        return '';
    const adjustmentName = (adjustment === null || adjustment === void 0 ? void 0 : adjustment.name) ||
        ((adjustment === null || adjustment === void 0 ? void 0 : adjustment.adjustmentType) === domain_1.AdjustmentType.SURCHARGE
            ? 'Surcharge'
            : 'Discount');
    const amount = Math.abs(adjustment === null || adjustment === void 0 ? void 0 : adjustment.amount).toString();
    let formattedAmount = `(${Math.abs(adjustment === null || adjustment === void 0 ? void 0 : adjustment.amount).toFixed(2)})`;
    if ((adjustment === null || adjustment === void 0 ? void 0 : adjustment.adjustmentUnit) === domain_1.AdjustmentUnit.PERCENTAGE)
        formattedAmount = ` (${amount}%)`;
    return `${adjustmentName}${formattedAmount}`;
};
exports.getAdjustmentLabel = getAdjustmentLabel;
const getOrderAdjustments = (order, fromPos = false) => {
    var _a, _b;
    const currencyFormatOptions = {
        code: ((_a = order === null || order === void 0 ? void 0 : order.organization) === null || _a === void 0 ? void 0 : _a.currencyCode) || 'AUD',
    };
    const formatCurrency = (0, exports.bindTrailingArgs)(currency_formatter_1.format, currencyFormatOptions);
    /*
    netSubTotal has the value after deducting the adjustments from the subTotal,
    This is be used for the Service charge/Tax
    */
    const netSubTotal = getNetSubTotal(order.subTotal, order.adjustments);
    const discounts = [];
    const surcharge = [];
    (_b = order.adjustments) === null || _b === void 0 ? void 0 : _b.forEach(adjustment => {
        const subTotal = adjustment.doNotIncludeInSalesAmount
            ? netSubTotal
            : order.subTotal;
        const adjustmentName = (0, exports.getAdjustmentLabel)(adjustment);
        if (adjustment.adjustmentType === domain_1.AdjustmentType.DISCOUNT) {
            // max adjustment is currently supported only by percentage discounts,
            // getadjustmentvalue fn returns the correct discount amount
            const discountValue = adjustment.adjustmentUnit === domain_1.AdjustmentUnit.FLAT
                ? adjustment.amount
                : getAdjustmentValue(subTotal, [adjustment]);
            const discountFormattedValue = fromPos
                ? discountValue.toFixed(2)
                : formatCurrency(discountValue);
            discounts.push({
                name: adjustmentName,
                adjustmentFormattedValue: discountFormattedValue,
                adjustmentValue: discountValue,
            });
        }
        else {
            const surchargeValue = adjustment.adjustmentUnit === domain_1.AdjustmentUnit.FLAT
                ? adjustment.amount
                : subTotal * adjustment.amount * 0.01;
            const surchargeFormattedValue = fromPos
                ? surchargeValue.toFixed(2)
                : formatCurrency(surchargeValue);
            surcharge.push({
                name: adjustmentName,
                adjustmentFormattedValue: surchargeFormattedValue,
                adjustmentValue: surchargeValue,
            });
        }
    });
    return { discounts, surcharge };
};
exports.getOrderAdjustments = getOrderAdjustments;
/**
 * Get total tips from Payments.
 * @param payments Order payments array
 * @returns Tip number
 */
function getTipsFromPayments(payments) {
    return payments.reduce((acc, payment) => {
        if (payment.status === undefined ||
            isCompletedOrRefundedPayment(payment.status)) {
            acc = sumDecimals([acc, payment.tip || 0]);
        }
        return acc;
    }, 0);
}
exports.getTipsFromPayments = getTipsFromPayments;
function isInventoryBeingTracked(storesInventory, currentStore, isTraining) {
    var _a;
    if (isTraining || !(storesInventory === null || storesInventory === void 0 ? void 0 : storesInventory[currentStore]))
        return false;
    return (_a = storesInventory === null || storesInventory === void 0 ? void 0 : storesInventory[currentStore]) === null || _a === void 0 ? void 0 : _a.isBeingTracked;
}
exports.isInventoryBeingTracked = isInventoryBeingTracked;
function getCurrentQuantity(product, currentStore) {
    var _a, _b;
    return ((_b = (_a = product === null || product === void 0 ? void 0 : product.storesInventory) === null || _a === void 0 ? void 0 : _a[currentStore]) === null || _b === void 0 ? void 0 : _b.availableQuantity) || 0;
}
exports.getCurrentQuantity = getCurrentQuantity;
function getOnAccountPayment(payments) {
    return payments.find(p => { var _a; return ((_a = p.paymentType) === null || _a === void 0 ? void 0 : _a.name) === domain_1.OrderAction.ON_ACCOUNT_PAYMENT_TYPE; });
}
exports.getOnAccountPayment = getOnAccountPayment;
function isOnAccountPayment(payment) {
    var _a;
    return !!(((_a = payment.paymentType) === null || _a === void 0 ? void 0 : _a.name) === domain_1.OrderAction.ON_ACCOUNT_PAYMENT_TYPE &&
        [domain_1.OrderPaymentStatus.PENDING, domain_1.OrderPaymentStatus.PART_PAID].includes(payment.status));
}
exports.isOnAccountPayment = isOnAccountPayment;
function isCompletedOrRefundedPayment(paymentStatus) {
    return [
        domain_1.OrderPaymentStatus.COMPLETE,
        domain_1.OrderPaymentStatus.REFUND_IN_PROGRESS,
        domain_1.OrderPaymentStatus.SENT_FOR_REFUND,
        domain_1.OrderPaymentStatus.REFUND_FAILED,
    ].includes(paymentStatus);
}
exports.isCompletedOrRefundedPayment = isCompletedOrRefundedPayment;
function canPerformTransfer(sourceTableId, targetTableId) {
    return targetTableId && sourceTableId !== targetTableId;
}
exports.canPerformTransfer = canPerformTransfer;
function getTablesFromOrder(order) {
    var _a;
    if ((_a = order === null || order === void 0 ? void 0 : order.tables) === null || _a === void 0 ? void 0 : _a.length)
        return order.tables.filter(Boolean);
    return (order === null || order === void 0 ? void 0 : order.table) ? [order.table] : [];
}
exports.getTablesFromOrder = getTablesFromOrder;
function getTableNameFromOrder(order) {
    const tables = getTablesFromOrder(order);
    const uniqueNames = [...new Set(tables.map(table => table.name))];
    return uniqueNames.join(',');
}
exports.getTableNameFromOrder = getTableNameFromOrder;
function getSectionNameFromOrder(order) {
    const tables = getTablesFromOrder(order);
    const uniqueNames = [
        ...new Set(tables.map(table => { var _a; return (_a = table.section) === null || _a === void 0 ? void 0 : _a.name; }).filter(Boolean)),
    ];
    return uniqueNames.join(',');
}
exports.getSectionNameFromOrder = getSectionNameFromOrder;
function filterCompletePayment(orderPayment) {
    return orderPayment.status === domain_1.OrderPaymentStatus.COMPLETE;
}
exports.filterCompletePayment = filterCompletePayment;
function searchOrderItemById(orderItems, orderItemId) {
    const foundItem = orderItems.find(item => item.id === orderItemId);
    if (foundItem) {
        return foundItem;
    }
    // If not found, check the mergedItemIds
    const foundMergedItem = orderItems.find(item => (item.mergedOrderItemIds || []).includes(orderItemId));
    return foundMergedItem;
}
exports.searchOrderItemById = searchOrderItemById;
//# sourceMappingURL=utils.js.map